export default __webpack_public_path__ + "static/media/EAST2450.34I-34248_-18470_0.8b7e5f7e.jpg";